import { useTranslation } from '@infield/features/i18n/use-translation';
import { createContext } from 'react';

import { createChecklistsSequentially } from '../utils/create-checklists-sequentially';
import { showChecklistCreationToast } from '../utils/show-checklist-creation-toast';

import { useCreatePlannedChecklistsMutation } from './use-create-planned-checklists-mutation';
import { useFetchChecklistsFromSchedulerQuery } from './use-fetch-checklists-from-scheduler-query';
import { useSchedulesDataGridStates } from './use-schedules-data-grid-states';
import { useSchedulesTableSelectedDateFilter } from './use-schedules-table-selected-date-filter';

export interface UseSchedulesPageContextInterface {
  useTranslation: typeof useTranslation;
  useSchedulesTableSelectedDateFilter: typeof useSchedulesTableSelectedDateFilter;
  useCreatePlannedChecklistsMutation: typeof useCreatePlannedChecklistsMutation;
  useFetchChecklistsFromSchedulerQuery: typeof useFetchChecklistsFromSchedulerQuery;
  useSchedulesDataGridStates: typeof useSchedulesDataGridStates;
  createChecklistsSequentially: typeof createChecklistsSequentially;
  showChecklistCreationToast: typeof showChecklistCreationToast;
}

export const UseSchedulesPageContext =
  createContext<UseSchedulesPageContextInterface>({
    useTranslation,
    useSchedulesTableSelectedDateFilter,
    useCreatePlannedChecklistsMutation,
    useFetchChecklistsFromSchedulerQuery,
    useSchedulesDataGridStates,
    createChecklistsSequentially,
    showChecklistCreationToast,
  });
